// About.js - Updated with photo and enhanced content
import { motion } from 'framer-motion';
import { FiUser, FiAward, FiBriefcase, FiCpu } from 'react-icons/fi';
import './About.css';

// You'll need to add your photo to the public folder or import it
// For now, we'll use a placeholder - replace with your actual photo path
import profilePhoto from '../assets/shyam.webp'; 

function About() {
  const highlights = [
    {
      icon: FiBriefcase,
      title: 'Experience',
      value: '1+ Year',
      detail: 'Full-Stack Development',
    },
    {
      icon: FiAward,
      title: 'Projects Deployed',
      value: '20+ Active',
      detail: 'Enterprise Clients',
    },
    {
      icon: FiCpu,
      title: 'Users Served',
      value: '50K+',
      detail: 'Active Users',
    },
    {
      icon: FiUser,
      title: 'Retention',
      value: '100%',
      detail: 'Client Satisfaction',
    },
  ];

  return (
    <section id="about" className="about section">
      <motion.div 
        className="section-title-wrap" 
        initial={{ opacity: 0, y: 20 }} 
        whileInView={{ opacity: 1, y: 0 }} 
        viewport={{ once: true }} 
        transition={{ duration: 0.5 }}
      >
        <FiUser className="section-title-icon" aria-hidden />
        <h2 className="section-title section-title--inline">About Me</h2>
      </motion.div>
      
      <div className="about__container">
        {/* Photo Section */}
        <motion.div 
          className="about__image-wrapper"
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.1 }}
        >
          <div className="about__image-card glass">
            <motion.div 
              className="about__badge"
              initial={{ scale: 0 }}
              whileInView={{ scale: 1 }}
              viewport={{ once: true }}
              transition={{ delay: 0.5, type: "spring" }}
            >
              Open to Work
            </motion.div>
            <img 
              src={profilePhoto} 
              alt="Shyam Ranjan - Professional Full-Stack Web Developer and Software Engineer, founder of Ranjan Solution web development agency" 
              className="about__image"
              loading="lazy"
              width="300"
              height="300"
            />
            <div className="about__image-caption">
              <p><strong>Shyam Ranjan</strong></p>
              <p>Full-Stack Developer & Founder</p>
            </div>
          </div>
        </motion.div>

        {/* Content Section */}
        <motion.div
          className="about__content"
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          <p className="about__lead">
            Hi there! I'm <strong>Shyam Ranjan</strong>, a <strong>professional full-stack web developer</strong> and <strong>Founder of Ranjan Solution</strong>, a specialized <strong>web development agency</strong> delivering <strong>custom web applications</strong> for growing businesses with 20+ active production deployments serving thousands of users.
          </p>
          
          <p className="about__text">
            As a <strong>skilled full-stack developer</strong> with <strong>1+ year of hands-on experience in web development</strong>, I specialize in building <strong>scalable web applications</strong>, <strong>responsive websites</strong>, and <strong>enterprise software solutions</strong> using modern <strong>web technologies</strong> including <strong>PHP, MySQL, JavaScript, React, Node.js</strong> and leading <strong>frontend frameworks</strong>. I've successfully <strong>architected and deployed</strong> a comprehensive <strong>School Management System</strong> serving 1000+ users across 2 client institutions, implementing <strong>role-based access control</strong>, <strong>real-time attendance tracking</strong>, and <strong>interactive parent-teacher portals</strong>.
          </p>

          {/* Highlights Grid */}
          <div className="about__highlights">
            {highlights.map((item, index) => {
              const Icon = item.icon;
              return (
                <motion.div 
                  key={item.title}
                  className="about__highlight-item"
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: 0.3 + index * 0.1 }}
                >
                  <Icon style={{ color: 'var(--accent)', marginBottom: '0.5rem' }} />
                  <h4>{item.title}</h4>
                  <p>{item.value}</p>
                  <small>{item.detail}</small>
                </motion.div>
              );
            })}
          </div>

          <p className="about__text">
            I developed the ExamKit educational platform, a scalable ed-tech web application that provides centralized access to 20+ examination papers and structured digital learning resources. This production-ready platform demonstrates my ability to design and deliver real-world web applications that improve content accessibility, streamline user workflows, and support high-engagement learning environments.
          </p>

          <p className="about__text">
            From initial requirements analysis and system architecture planning to deployment and long-term maintenance, I follow a complete, user-focused development approach. I prioritize performance, security, and intuitive user experience while building scalable, maintainable web solutions that solve real business and educational challenges. I am committed to delivering reliable, high-quality applications and collaborating on impactful web projects that drive measurable results.
          </p>
        </motion.div>
      </div>
    </section>
  );
}

export default About;